const themeModules = import.meta.glob('./*.css', {
  query: '?url',
  eager: true,
  import: 'default'
})

function getUrl(entry: unknown): string | undefined {
  if (typeof entry === 'string') return entry
  if (entry && typeof entry === 'object' && 'default' in entry && typeof (entry as { default: string }).default === 'string') {
    return (entry as { default: string }).default
  }
  return undefined
}

const THEME_IDS = Object.keys(themeModules)
  .map((path) => path.replace(/^.*\/([^/]+)\.css$/, '$1'))
  .filter(Boolean)
  .sort()

const themeUrlById: Record<string, string> = {}
for (const path of Object.keys(themeModules)) {
  const id = path.replace(/^.*\/([^/]+)\.css$/, '$1')
  const url = getUrl(themeModules[path])
  if (url) themeUrlById[id] = url
}

export function getThemeIds(): string[] {
  return [...THEME_IDS]
}

export function getThemeUrl(id: string): string | undefined {
  return themeUrlById[id]
}

export function themeIdToLabel(id: string): string {
  const base = id.replace(/\.css$/, '')
  return base
    .split(/[-_]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
